import Resource from '@/api/core/resource'

class Notificacion extends Resource {
  constructor () {
    super('notificacion')
  }

  obtenerNotificaciones (userId) {
    return this.request.get(this.uri.concat('/').concat(userId))
  }

  obtenerNotificacionesNuevas (userId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(userId)
        .concat('/nuevas')
    )
  }

  finalizar (notificacionId, params) {
    return this.request.post(
      this.uri
        .concat('/')
        .concat(notificacionId)
        .concat('/finalizar'),
      params
    )
  }
}

export default new Notificacion()
